import { LOGIN_VERIFIED, LOGIN_FAILED_TO_VERIFY, OTP_RESENT } from '../actions/verify';

const INITIAL_STATE = {
    info: {},
    message: ''
};

const verifyReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOGIN_VERIFIED:
            state = { ...state, info: action.payload };
            return state;
        case LOGIN_FAILED_TO_VERIFY:
            state = { ...state, info: {}, message: action.payload };
            return state;
        case OTP_RESENT:
            state = {...state, message: action.payload};
            return state;
        default:
            return state;
    }
}

export default verifyReducer;